export default {"src":"/_next/static/media/paper-plane.0529ae4a.svg","height":267,"width":1059,"blurWidth":0,"blurHeight":0};